<template>
  <i class="icon_wrap"></i>
</template>

<script>
export default {
  name: 'Account'
};
</script>

<style scoped lang="stylus">
.icon_wrap {
  display inline-block
  width 40px
  height 43px
  background-size 40px 43px
  background-repeat no-repeat
  background-position center
  background-image url('./images/cdk_icon_account.png')
  background-image image-set(url('./images/cdk_icon_account.png') 1x, url('./images/cdk_icon_account@2x.png') 2x)
}
</style>
